import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponse } from '../../../../shared/models/qcResponse.model';

export const OpenUpdateDateDialog = createAction(
  '[Data Customization: Tag Assignment]: Open Edit Date Dialog',
  props<{ dateFormat: string; column: string }>(),
);

export const DateChanged = createAction(
  '[Data Customization: Tag Assignment]: Date Changed',
  props<{ date: Date; dateFormat: string }>(),
);

export const UpdateDate = createAction('[Data Customization: Tag Assignment]: Updating Date');

export const UpdateDateSuccess = createAction(
  '[Data Customization: Tag Assignment]: Update Date Success',
  props<{ res: QcResponse }>(),
);

export const UpdateDateFailed = createAction(
  '[Data Customization: Tag Assignment]: Update Date Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CloseEditDateDialog = createAction(
  '[Data Customization: Tag Assignment]: Close Edit Date Dialog',
);
